import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';

const notifyMe = async (payload: any) => {
  const endPoint = `${apiConfig(
    'magento'
  )}/default/V1/custom/homepage/notifyMe`;

  const { response, error }: any = await postMethod({
    endPoint,
    body: payload,
    headers: getDefaultHeaders({ deviceId: true }),
  });

  if (response) {
    return true;
  } else if (error) {
    return false;
  }
};

export default notifyMe;
